import { RouteItem } from '@eastcoal/router/types/route'

import { MESSAGE_PAGE_PATH } from './constants/path'

export const messageRoute: RouteItem = {
  title: '消息中心',
  path: MESSAGE_PAGE_PATH,
  hideInMenu: true,
  Component: () => import('./index')
}
